<div class="modal-header">
	<h4 class="modal-title">{{displayString(name)}}</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="status-bar">
	<!-- Schweregrad -->
	<div class="status-group">
		<span class="status-label">Schweregrad:</span>
		<div class="btn-group btn-group-sm" role="group">
			<button type="button" class="btn btn-danger"
				[class.active]="comments.type === VL.danger"
				[class.inactive]="comments.type !== VL.danger"
				[disabled]="!canChangeSeverity()"
				(click)="comments.type = VL.danger"
				title="Fehler - muss korrigiert werden">
				<bi name="exclamation-circle"></bi>
			</button>
			<button type="button" class="btn btn-warning"
				[class.active]="comments.type === VL.warning"
				[class.inactive]="comments.type !== VL.warning"
				[disabled]="!canChangeSeverity()"
				(click)="comments.type = VL.warning"
				title="Hinweis - sollte geprüft werden">
				<bi name="exclamation-triangle"></bi>
			</button>
			<button type="button" class="btn btn-info"
				[class.active]="comments.type === VL.ok"
				[class.inactive]="comments.type !== VL.ok"
				[disabled]="!canChangeSeverity()"
				(click)="comments.type = VL.ok"
				title="Info - zur Kenntnis">
				<bi name="info-circle"></bi>
			</button>
		</div>
	</div>
	<!-- Bearbeitungsstatus -->
	<div class="status-group">
		<span class="status-label">Status:</span>
		<button type="button" class="btn btn-sm"
			[ngClass]="comments.resolved ? 'btn-success' : 'btn-outline-secondary'"
			[disabled]="!canResolve()"
			(click)="onResolve()"
			[title]="comments.resolved ? 'Als offen markieren' : 'Als erledigt markieren'">
			<bi [name]="comments.resolved ? 'check-circle-fill' : 'circle'"></bi>
			<span class="status-text">{{comments.resolved ? 'Erledigt' : 'Offen'}}</span>
		</button>
	</div>
</div>
<div class="modal-body">
	<wd-comments [inline]="false" [name]="name" [comments]="comments"></wd-comments>
</div>
<div class="modal-footer">
	<button *ngIf="canDelete()" type="button" class="btn btn-outline-danger btn-sm" (click)="onDelete()"><bi name="trash"></bi></button>
	<button type="button" class="btn btn-outline-secondary btn-sm" (click)="onClose()">Speichern</button>
</div>
